export default __webpack_public_path__ + "media/images/corp/wavy1-880959a74e3535e30198c096532d5eab.png";